import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

export const authenticateUser = (employeeCode, password) =>
    axios.post(`${apiUrl}user/authenticate`, {
        employeeCode,
        password
    });

export const authenticateCustomer = (employeeCode, password) =>
    axios.post(`${apiUrl}user/authenticateCustomer`, {
        employeeCode,
        password
    });

export const requestNewToken = (token, refreshToken) =>
    axios.post(`${apiUrl}user/refresh`, {
        token,
        refreshToken
    });
